export default __webpack_public_path__ + "static/media/dxzg_about.e3b96ff3.jpg";